import React from "react";
import { PillButton } from "./DayPill.styles";
import type { PillSizeKey } from "../../../design-system/tokens/controlSizes";

export interface DayPillProps {
  letter: string;
  selected: boolean;
  onClick: () => void;
  ariaLabel?: string;
  /** `"dayPill"` is the 36px diameter used by schedule "Repeat on" rows. */
  size?: PillSizeKey;
  compact?: boolean;
}

export const DayPill: React.FC<DayPillProps> = ({
  letter,
  selected,
  onClick,
  ariaLabel,
  size = "md",
  compact = false,
}) => (
  <PillButton
    type="button"
    role="switch"
    aria-checked={selected}
    aria-label={ariaLabel ?? letter}
    $selected={selected}
    $size={size}
    onClick={onClick}
    $compact={compact}
  >
    {letter}
  </PillButton>
);

export default DayPill;
